import { createAsyncThunk } from '@reduxjs/toolkit'
import SystemNumberService from 'services/system-number'

export const getSystemNumber = createAsyncThunk(
	'systemnumber/get',
	SystemNumberService.getSystemNumber
)
